import { useMatchingRoutePath } from '@csp/csp-web-hooks';
import { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalyticsContext } from '../context/useAnalyticsContext';

type Props = {
  routesMap: Record<string, string>;
};
export const AnalyticsPageTracker: FC<Props> = ({ routesMap }) => {
  const { pathname, search } = useLocation();
  const previousPathName = useRef<string>('');
  const previousSearch = useRef<string>('');
  const analytics = useAnalyticsContext();
  const matchingRoutePath = useMatchingRoutePath({ routesMap });

  useEffect(() => {
    if (!analytics.isInitialized) {
      return;
    }

    const didPathNameChange = previousPathName.current !== pathname;
    const didSearchChange = previousSearch.current !== search;

    if ((didPathNameChange || didSearchChange) && matchingRoutePath) {
      analytics.page(matchingRoutePath);
      previousPathName.current = pathname;
      previousSearch.current = search;
    }
  }, [pathname, analytics, matchingRoutePath, search]);
  return null;
};
